import { render } from "./OtherRecord.vue?vue&type=template&id=0df46cb5&scoped=true&ts=true"
import script from "./OtherRecord.vue?vue&type=script&lang=ts"
export * from "./OtherRecord.vue?vue&type=script&lang=ts"

import "./OtherRecord.vue?vue&type=style&index=0&id=0df46cb5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0df46cb5"]])

export default __exports__